var $6e034876d49a8abb$exports = {};
$6e034876d49a8abb$exports = {
    "collectionLabel": `Suggestions`
};


export {$6e034876d49a8abb$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
